import { reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

const state = reactive({
  title: null,
  message: null,
  payload: null,
  confirmText: null,
  cancelText: null,
  hideCancel: false,
  hideConfirm: false,
  hideOverlay: false,
  opened: false,
  onConfirm: () => {},
  onCancel: () => {},
  type: 'default',
})

export const useNotifier = () => {
  const { t } = useI18n()

  const open = ({ title, message, payload, onConfirm, onCancel, cancelText, confirmText, hideCancel, hideConfirm, hideOverlay, type = 'default' } = {}) => {
    const defaultCancel = t('component.notify.cancel')
    const defaultConfirm = t('component.notify.continue')

    state.title = title
    state.message = message
    state.confirmText = confirmText ?? defaultConfirm
    state.cancelText = cancelText ?? defaultCancel
    state.payload = payload
    state.opened = true
    state.hideCancel = !!hideCancel
    state.hideConfirm = !!hideConfirm
    state.hideOverlay = !!hideOverlay
    state.onConfirm = onConfirm || (() => {})
    state.onCancel = onCancel || (() => {})
    state.type = type
  }

  const close = () => {
    state.title = null
    state.message = null
    state.confirmText = null
    state.cancelText = null
    state.payload = null
    state.opened = false
    state.hideCancel = false
    state.hideConfirm = false
    state.hideOverlay = false
    state.onConfirm = () => {}
    state.onCancel = () => {}
    state.type = 'default'
  }

  return { open, close, ask: open, ...toRefs(state) }
}
